const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const barcodeKey = (value) => String(value || "").trim().toLowerCase();

export function calculateTransactionProfit(
  transactionItems = [],
  catalogItems = [],
  barcodeLinks = [],
) {
  const itemsById = new Map(
    catalogItems.map((item) => [String(item.id), item]),
  );
  const itemIdsByBarcode = new Map();

  catalogItems.forEach((item) => {
    const key = barcodeKey(item.barcode);
    if (key) itemIdsByBarcode.set(key, item.id);
  });
  barcodeLinks.forEach((link) => {
    const key = barcodeKey(link.barcode);
    if (key) itemIdsByBarcode.set(key, link.item_id);
  });

  return transactionItems.reduce((total, line) => {
    const linkedItemId =
      line.item_id ?? itemIdsByBarcode.get(barcodeKey(line.barcode));
    const catalogItem = itemsById.get(String(linkedItemId));
    if (catalogItem?.base_price == null) return total;

    const soldQuantity = toNumber(line.quantity);
    const baseQuantity =
      line.base_quantity == null
        ? soldQuantity
        : toNumber(line.base_quantity);
    const revenue = toNumber(line.unit_price) * soldQuantity;
    const cost = toNumber(catalogItem.base_price) * baseQuantity;

    return total + revenue - cost;
  }, 0);
}
